import React, { useState, useEffect } from "react";
import { Menu, Skeleton, Table, Select, Typography } from "antd";

import { CheckCircleOutlined } from '@ant-design/icons';
import moment from 'moment';

import * as Styled from './style.js';
import { postData,getData } from '../../config/api-connect';

const { Option } = Select;

const CourtBookingSummary = ({ venue_id, sport, courtSizes, month, year }) => {
  const [currentTab, setCurrentTab] = useState("hourly");
  const [courtId, setCourtId] = useState('')
  const [header, setHeader] = useState([])
  const [cbData, setCBData] = useState([])
  const [loader, setloader] = useState(false)

  const handleClick = (e) => {
    setCurrentTab(e.key);
  };

  useEffect(() => {
    if (courtSizes && courtSizes.length > 0) {
      setCourtId(courtSizes[0].id)
    }
  }, [courtSizes]);

  useEffect(() => {
    if(sport && (courtId || courtId === 0)){
      getCourtBookingAnalysis()
    }
  },[sport,courtId,month,year])

  const getCourtBookingAnalysis= () => {
    setloader(true)
    const startDate = moment([year, month - 1]).startOf('month').format('YYYY-MM-DD');
    const endDate = moment([year, month - 1]).endOf('month').format('YYYY-MM-DD');
    getData(`/eagleeye/getTableData/?report_id=76385&venue_id=${venue_id}&date=${startDate}&end_date=${endDate}&game_type_id=${sport}&category=${courtId}`)
    .then(response =>{
      setHeader(response.headers)
      setCBData(response.data)
      setloader(false)
    })
    .catch(error => {
      setloader(false)
      console.log(error.message);
    });
  }

  const getColorFromHours = (utilization) => {
    const greenStart = [212, 237, 218]
    const greenEnd = [0, 100, 0]

    const r = Math.round(greenStart[0] + (greenEnd[0] - greenStart[0]) * (utilization / 100));
    const g = Math.round(greenStart[1] + (greenEnd[1] - greenStart[1]) * (utilization / 100));
    const b = Math.round(greenStart[2] + (greenEnd[2] - greenStart[2]) * (utilization / 100));

    return `rgb(${r}, ${g}, ${b})`;
  };
 
  const heatmap_columns = header.map((title, index) => ({
    title,
    dataIndex: index.toString(),
    key: title,
    align: 'center',
    width: 125,
    render: (text) => {
      return text;
    },
    onCell: (record) => {
      const value = record[index];
      if (isNaN(Number(value))) return {};
      return {
        style: getCellStyle(value, courtId, courtSizes)
      };
    }
  }));

  const getCellStyle = (text, courtId, courtSizes) => {
    const court_size = courtSizes.find(court => court.id === courtId);
    const no_of_courts = court_size?.no_of_courts || 1;

    const maxUtilization = no_of_courts * 4;
    const utilization = (Number(text) / maxUtilization) * 100;
    const backgroundColor = getColorFromHours(utilization);
    const color = utilization > 60 ? 'white' : 'black';

    return {
      backgroundColor,
      color,
      textAlign: 'center'
    };
  };

  const rowData = cbData.map((row, rowIndex) => {
      const rowObj = {};
      row.forEach((cell, cellIndex) => {
          rowObj[cellIndex] = cell;
      });
      return { key: rowIndex, ...rowObj };
  });

  return (
    <div style={{padding: 10}}>
      <Menu onClick={handleClick} selectedKeys={currentTab} mode="horizontal">
        {/*<Menu.Item key="summary">Summary</Menu.Item>
        <Menu.Item key="list">Customer List</Menu.Item>*/}
        <Menu.Item key="hourly">Hourly Analysis</Menu.Item>
      </Menu>

      <div style={{ marginTop: '1%' }}>
        {currentTab === "hourly" && 
          <div>
            {loader ?
              <Skeleton active paragraph={{ rows: 7 }} />
            :
              <div>
                {courtSizes && courtSizes.length > 1 &&
                  <Select className = 'mainSelector'
                    style={{width: 150,marginBottom:'1%'}}
                    onChange={setCourtId}
                    value = {courtId}
                    bordered={false}
                  >
                    {courtSizes.map((size,index) => (
                      <Option value={size.id} key={index}> {size.name} </Option>
                    ))}
                  </Select>
                }

                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                  * Values indicate the number of hours utilized.
                </Typography.Text>

                <Table
                  className="drill-down-table table_container"
                  rowKey="id"
                  columns={heatmap_columns} 
                  dataSource={rowData}
                  pagination={false}
                  bordered
                 />
              </div>
            }
          </div>
        }

      </div>
    </div>
  );
};

export default CourtBookingSummary;
